module.exports = __webpack_public_path__ + "img/2.94a0d589.jpg";